import OpenSeadragon from "openseadragon";
import ImageView from "./Image.js";

const _debug = false;
const _homeZoomPadding = 0.1;
const _defaultSliderDilation = 12;

const _config = {
    zoomOutOnStartup: true,
    snapToHomeOnZoomingOut: true,
    initialPosition: {
        zoom: undefined,
        center: undefined,
        rotation: undefined
    }
} 

export default class ZoomControls {

    /** 
     * 
     * @param {ImageView} imageView 
     * @param {Object} config 
     */
    constructor(imageView, config) {
        this.imageView = imageView
        this.zoomConfig = imageView.config.zoom;
        this.zoomingHome = false;
        this.config = jQuery.extend(true, {}, _config, config ?? imageView.config.controls.zoom);
        this.initialPosition = this.config.initialPosition;
        this.homeZoom = 1;

        this.imageView.onOpened.subscribe( () => {
            this.homeZoom = this.imageView.openseadragon.viewport.getHomeZoom();
            if(this.initialPosition) {
                this.setPosition(this.initialPosition);
            } else if(this.config.zoomOutOnStartup) {
                this.goHome();
            }
        });

        if(this.config.snapToHomeOnZoomingOut) {
            this.imageView.onRedraw.subscribe( () => {
                if(!this.zoomingHome && this.isZoomedOut()) {
                   this.goHome();
                }
            });
    
            this.imageView.onZoom.subscribe( e => {
                if(!this.zoomingHome && this.isZoomingOut() && this.isZoomedOut()) {
                    //console.log("zoomed out, go home");
                    this.goHome();
                }
            })
        }
    }


    setInput(element) {
        if(element) {
            this.input = new Input(this, _getElement(element));
        }
        return this.input;
    }

    setSlider(element, dilation) {
        if(element) {
            this.slider = new Slider(this, _getElement(element), dilation);
        }
        return this.slider;
    }

    close() {
        this.input?.close();
        this.sloder?.close();
        
    }

    isZoomingOut() {
            const lastZoom = this.imageView.openseadragon.viewport.getZoom();
            const nextZoom = this.imageView.openseadragon.viewport.getZoom(true);
            return nextZoom > lastZoom;
    }

    goHome() {
        this.zoomingHome = true;
        this.imageView.openseadragon.viewport.goHome(true);
        const bounds = this.imageView.getCurrentRow().map(image => image.getBounds()).reduce((b1,b2) => b1.union(b2));
        const imageBounds = this.imageView.getCurrentImage().getBounds();
        if(_debug)console.log("current image bounds ", this.imageView.getCurrentImage(), imageBounds);
        const canvasSize = this.imageView.extent.canvasSize;
        const aspectRatioImage = imageBounds.width / imageBounds.height;
        const aspectRatioRow = bounds.width / bounds.height;
        //console.log("ascpect ratios ", aspectRatioImage, aspectRatioRow); 
        const homeBounds = this.imageView.openseadragon.viewport.getHomeBounds();
         let newBounds = new OpenSeadragon.Rect(bounds.x, bounds.y, bounds.width, bounds.height);
        if(bounds) {
               //console.log("bounds", bounds);
               //console.log("imageBounds ", imageBounds);
               //console.log("homeBounds ", homeBounds);
              const rotation = this.imageView.openseadragon.viewport.getRotation();

            if(this.imageView.config.fittingMode === "toWidth") {
                switch(_normalizeAngle(rotation)) {  
                    case 180: 
                        newBounds.y = -(homeBounds.height/homeBounds.width - bounds.height/bounds.width)/2 * this.imageView.getCurrentRow().length;
                        break;
                    case 90:
                        newBounds.x = (homeBounds.width/(homeBounds.height) - bounds.width/bounds.height) * 1/aspectRatioImage/2;
                        break;
                    case 270:
                        newBounds.x = -(homeBounds.width/homeBounds.height - bounds.width/bounds.height) * 1/aspectRatioImage/2;
                        break; 
                    default:
                        newBounds.y += Math.max(0,(homeBounds.height/homeBounds.width - bounds.height/bounds.width)/2 * this.imageView.getCurrentRow().length);
                }
            } else if(this.imageView.config.fittingMode === "fixed") { 
                const marginBottom = this.imageView.extent.viewportMargins.bottom ;
                const marginRight = this.imageView.extent.viewportMargins.right;
                // const marginLeft = this.imageView.extent.viewportMargins.left;
                // const margiTop = this.imageView.extent.viewportMargins.top;
               
                switch(_normalizeAngle(rotation)) {
                    case 180:
                        newBounds.y = - bounds.height * marginBottom / (canvasSize.y - marginBottom);
                        newBounds.height = bounds.height*canvasSize.y / (canvasSize.y - marginBottom);
                        newBounds.width = bounds.width*canvasSize.x / (canvasSize.x - marginRight);
                        newBounds.x = - bounds.width * marginRight / (canvasSize.x - marginRight);
                        break;
                    case 90:
                        newBounds.y = - bounds.height * marginRight / (canvasSize.x - marginRight);
                        newBounds.height = bounds.height*canvasSize.x / (canvasSize.x - marginRight);
                        newBounds.width = bounds.width*canvasSize.y / (canvasSize.y - marginBottom);
                        break;
                    case 270:
                        newBounds.height = bounds.height*canvasSize.x / (canvasSize.x - marginRight);
                        newBounds.x = - bounds.width * marginBottom / (canvasSize.y - marginBottom);
                        newBounds.width = bounds.width*canvasSize.y / (canvasSize.y - marginBottom);
                        break; 
                    default:
                        newBounds.width = bounds.width*canvasSize.x / (canvasSize.x - marginRight);
                        newBounds.height = bounds.height*canvasSize.y / (canvasSize.y - marginBottom);
                }
            }

            this.imageView.openseadragon.viewport.fitBounds(newBounds, true);
            this.homeZoom = this.imageView.openseadragon.viewport.getZoom();
            this.zoomingHome = false;
        }
    }

    setPosition(position) {
        if(position?.rotation) {
            this.setRotation(position.rotation, true);
        }
        if(position?.zoom || position?.center) {
            this.setZoom(position.zoom ?? this.getHomeZoom(), true);
            this.panTo(position.center ?? this.getHomeCenter(), true);
        } else {
            this.goHome();
        }
    }

    getPosition() {
        return {
            zoom: this.isZoomedOut() ? undefined : this.getZoom(),
            center: this.isZoomedOut() ? undefined : this.getCenter(),
            rotation: this.getRotation()
        }
    }

    getHomeCenter() {
        return this.imageView.openseadragon.viewport.getHomeBounds().getCenter();
    }

    getCenter() {
        return this.imageView.openseadragon.viewport.getBounds().getCenter();
    }

    getRotation() {
        return this.imageView.openseadragon.viewport.getRotation();
    }

    setRotation(degree, immediate) {
        this.imageView.openseadragon.viewport.rotateTo(degree, undefined, immediate);
    }

    panTo(center, immediate) {
        const centerPoint = new OpenSeadragon.Point(center.x, center.y);
        this.imageView.openseadragon.viewport.panTo(centerPoint, immediate);
    }

    getZoom() {
        return this.imageView.openseadragon.viewport.getZoom();
    }

    getHomeZoom() {
        return this.homeZoom ?? this.imageView.openseadragon.viewport.getHomeZoom();
    }

    setZoom(zoom, immediate) {
        this.imageView.openseadragon.viewport.zoomTo(zoom, undefined, immediate ?? true);
    }

    zoomTo(zoom) {
        this.setZoom(zoom, false);
    }

    zoomBy( zoomBy, originalEvent ) {
        if ( _debug ) {
            console.log( 'osViewer.controls.myZoomBy: zoomBy - ' + zoomBy );
            console.log( 'osViewer.controls.myZoomBy: originalEvent - ',  originalEvent );
            console.log("image center ", this.imageView.openseadragon.viewport.getCenter( false ));
        }
        if(zoomBy < 1 || this.imageView.openseadragon.viewport.getZoom() < this.zoomConfig.max) {
            if(originalEvent) {
                const point = this.imageView.openseadragon.viewport.viewerElementToViewportCoordinates(new OpenSeadragon.Point(originalEvent.layerX,originalEvent.layerY)); 
                this.imageView.openseadragon.viewport.zoomBy( zoomBy, point, false );
            } else {
                this.imageView.openseadragon.viewport.zoomBy( zoomBy );
            }
        }
    }

    isZoomedToMin() {
        
        if(this.imageView.isRotated()) {
            const aspectRatio = this.imageView.openseadragon.world.getItemAt(0).source.aspectRatio;
            return this.imageView.openseadragon?.viewport?.getZoom() < (this.getHomeZoom()) - _homeZoomPadding;
        } else {
            return this.imageView.openseadragon?.viewport?.getZoom() < this.getHomeZoom() - _homeZoomPadding;
        }

    }


    isZoomedOut() {
        
        if(this.imageView.isRotated()) {
            const aspectRatio = this.imageView.openseadragon.world.getItemAt(0).source.aspectRatio;
            return this.imageView.openseadragon?.viewport?.getZoom() < (this.getHomeZoom()) + _homeZoomPadding;
        } else {
            return this.imageView.openseadragon?.viewport?.getZoom() < this.getHomeZoom() + _homeZoomPadding;
        }

    }

}

class Input {

    constructor(zoomControl, inputElement) {
        this.zoomControl = zoomControl;
        this.element = inputElement
        this.factor = 100; //display zoom in percent
        if(this.zoomControl.imageView.tileSources) {
            this.element.value = this.getValue();
        } else {
            this.zoomControl.imageView.onOpened.subscribe(e => {
                this.element.value = this.getValue();
            });
        }
        this.changeEvent = e => this.setValue(parseFloat(e.target.value));
        this.element.addEventListener("change", this.changeEvent);
        this.zoomSubscription = this.zoomControl.imageView.onZoom.subscribe(e => inputElement.value = this.getValue());
    }

    getValue() {
        const value = _getZoomValue(this.zoomControl.getZoom(), this.zoomControl.imageView.getOriginalImageSize(), this.zoomControl.imageView.extent.canvasSize) * this.factor;
        return value.toFixed(0);
    }

    setValue(value) {
       if(_debug) console.log("set zoom value ", value);
        const floatValue = parseFloat(value);
        if(!isNaN(floatValue)) {
            const zoom = _getZoom(value, this.zoomControl.imageView.getOriginalImageSize(), this.zoomControl.imageView.extent.canvasSize) / this.factor;
            const boxedZoom = Math.min(Math.max(zoom, this.zoomControl.imageView.config.zoom.min), this.zoomControl.imageView.config.zoom.max)
            this.zoomControl.setZoom(boxedZoom);
        }
    }

    close() {
        this.element.removeEventListener("change", this.changeEvent);
        this.zoomSubscription.unsubscribe();
    }

}

class Slider {

    constructor(zoomControl, inputElement, dilation) {
        this.dilation = dilation ?? _defaultSliderDilation;
        this.zoomControl = zoomControl;
        this.element = inputElement;
        if(this.zoomControl.imageView.tileSources) {
            this.element.value = this.getValue();
        } else {
            this.zoomControl.imageView.onOpened.subscribe(e => {
                this.element.value = this.getValue();
            });
        }
        this.inputEvent = e => this.setValue(parseFloat(e.target.value));
        this.element.addEventListener("input", this.inputEvent);
        this.zoomSubscription = this.zoomControl.imageView.onZoom.subscribe(e => inputElement.value = this.getValue());
    }

    close() {
        this.element.removeEventListener("input", this.inputEvent);
        this.zoomSubscription.unsubscribe();
    }

    getValue() {
        const zoom = this.zoomControl.getZoom();
        const minZoom = this.zoomControl.imageView.config.zoom.min;
        const maxZoom = this.zoomControl.imageView.config.zoom.max * minZoom;
        const factor = ( (zoom - minZoom) / (maxZoom-minZoom) );
        const position = 1 / Math.atan( this.dilation ) * Math.atan( this.dilation * factor );
        return position;
    }

    setValue(value) {
       if(_debug) console.log("set zoom value ", value);
        const floatValue = parseFloat(value);
        if(!isNaN(floatValue)) {

            const factor = 1 / this.dilation * Math.tan( Math.atan( this.dilation ) * floatValue );
            const minZoom = this.zoomControl.imageView.config.zoom.min;
            const maxZoom = this.zoomControl.imageView.config.zoom.max * minZoom;
            const zoom = minZoom + factor * (maxZoom-minZoom);

            const boxedZoom = Math.min(Math.max(zoom, this.zoomControl.imageView.config.zoom.min), this.zoomControl.imageView.config.zoom.max)
            this.zoomControl.setZoom(boxedZoom);
        }
    }

}

function _normalizeAngle(angle) {
  return ((angle % 360) + 360) % 360;
}

function _getElement(elementOrSelector) {
    if(elementOrSelector && typeof elementOrSelector === "string") {
        return document.querySelector(elementOrSelector);
    } else if(elementOrSelector) {
        return elementOrSelector;
    }
}

function _getZoom(value, imageSize, canvasSize) {
    const imageWidth = imageSize.width ?? imageSize.x;
    const imageViewWidth = canvasSize.width ?? canvasSize.x;
    const zoom = parseFloat(value)*imageWidth/imageViewWidth;
    return zoom / window.devicePixelRatio;
}

function _getZoomValue(zoomFactor, imageSize, canvasSize) {
    const imageWidth = imageSize.width ?? imageSize.x;
    const imageViewWidth = canvasSize.width ?? canvasSize.x;
    const value = parseFloat(zoomFactor)*imageViewWidth/imageWidth;
    return value * window.devicePixelRatio;
}

